export const checkIsMobile = (width: number | undefined) => width !== undefined && width < 720
